// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__rKMvC","error":"Auth_error__nWHap"};